import { render, staticRenderFns } from "./InternalPromoDashboardComponent.vue?vue&type=template&id=436caa7a"
import script from "./InternalPromoDashboardComponent.vue?vue&type=script&lang=js"
export * from "./InternalPromoDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports